import { dynamicLoader } from '~/utils';

export const ServiceAreaSelector = dynamicLoader({
  name: 'ServiceAreaSelector',
  importFunc: () => import('./service-area-selector'),
});